"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _label = _interopRequireDefault(require("@ingka/label"));

var _button = _interopRequireDefault(require("@ingka/button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _visibilityHide = _interopRequireDefault(require("@ingka/ssr-icon/paths/visibility-hide"));

var _visibilityShow = _interopRequireDefault(require("@ingka/ssr-icon/paths/visibility-show"));

var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));

var _formField = require("@ingka/form-field");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const InputField = (0, _react.forwardRef)((props, ref) => {
  const {
    prefix,
    type,
    label,
    placeholder,
    req,
    inputMode,
    disabled,
    hidePasswordText,
    showPasswordText,
    className,
    prefixLabel,
    suffixLabel,
    id,
    describedById,
    ssrIcon,
    iconPosition,
    iconOnClick,
    iconClickDescription,
    onChange,
    ...other
  } = props;
  const {
    shouldValidate,
    valid,
    setCharacterCount
  } = (0, _react.useContext)(_formField.FormFieldContext);

  const togglePasswordVisibility = e => {
    e.preventDefault();
    setPasswordVisible(!passwordVisible);
  };

  const onChangeHandler = e => {
    if (setCharacterCount) {
      setCharacterCount(e.target.value.length);
    }

    setLabelled(e.target.value !== '');

    if (onChange) {
      onChange(e);
    }
  };

  const {
    value,
    defaultValue
  } = other;
  let defaultCharacterCount = 0;
  let defaultLabelled = false;

  if (value || value === 0) {
    defaultCharacterCount = value.length;
    defaultLabelled = value === 0 || value;
  } else if (defaultValue || defaultValue === 0) {
    defaultLabelled = defaultValue === 0 || defaultValue;
    defaultCharacterCount = defaultValue.length;
  }

  const [labelled, setLabelled] = (0, _react.useState)(defaultLabelled);
  const [passwordVisible, setPasswordVisible] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setLabelled(defaultLabelled);
  }, [defaultLabelled]);
  (0, _react.useEffect)(() => {
    if (setCharacterCount) {
      setCharacterCount(defaultCharacterCount);
    }
  }, [defaultCharacterCount]);
  const trailing = type === 'password' || iconPosition === 'trailing' && ssrIcon;
  const baseClass = `${prefix}input-field`;
  const classes = (0, _classnames.default)(`${baseClass}`, disabled && `${baseClass}--disabled`, prefixLabel && `${baseClass}--prefixed`, suffixLabel && `${baseClass}--suffixed`, ssrIcon && iconPosition === 'leading' && `${baseClass}--leading-icon`, trailing && `${baseClass}--trailing-icon`, labelled && `${baseClass}--labelled`, shouldValidate && !valid && `${baseClass}--error`, shouldValidate && valid && `${baseClass}--success`, `${prefix}label-wrapper ${prefix}label-wrapper--text-input`, className);
  const convertedType = type === 'number' ? 'text' : type;
  return _react.default.createElement("div", {
    className: classes
  }, label && _react.default.createElement(_label.default, {
    title: label,
    prefix: prefix,
    htmlFor: id,
    label: label
  }), _react.default.createElement("div", {
    className: `${baseClass}__wrapper`
  }, _react.default.createElement("input", _extends({
    ref: ref,
    type: passwordVisible ? 'text' : convertedType,
    id: id,
    disabled: disabled,
    required: req
  }, other, {
    onChange: onChangeHandler,
    inputMode: type === 'number' ? 'numeric' : inputMode,
    "aria-describedby": describedById,
    "aria-required": Boolean(req),
    "aria-invalid": shouldValidate ? !valid : null
  })), iconPosition === 'leading' && ssrIcon && _react.default.createElement(_ssrIcon.default, {
    prefix: prefix,
    paths: ssrIcon
  }), prefixLabel && _react.default.createElement("span", {
    className: `${baseClass}__prefix-label`
  }, prefixLabel), suffixLabel && _react.default.createElement("span", {
    className: `${baseClass}__suffix-label`
  }, suffixLabel), type === 'password' && _react.default.createElement(_button.default, {
    htmlType: "button",
    prefix: prefix,
    iconOnly: true,
    xsmallIconOnly: true,
    ssrIcon: passwordVisible ? _visibilityHide.default : _visibilityShow.default,
    onClick: togglePasswordVisibility,
    type: "plain",
    text: passwordVisible ? hidePasswordText : showPasswordText,
    disabled: disabled
  }), iconPosition === 'trailing' && ssrIcon && _react.default.createElement(_button.default, {
    htmlType: "button",
    prefix: prefix,
    xsmallIconOnly: true,
    ssrIcon: ssrIcon,
    iconOnly: true,
    onClick: iconOnClick ? iconOnClick : null,
    type: "plain",
    text: iconClickDescription,
    disabled: disabled
  }), _react.default.createElement("span", {
    className: `${baseClass}__border`
  })));
});
InputField.defaultProps = {
  prefix: '',
  type: 'text',
  label: '',
  req: false,
  disabled: false,
  hidePasswordText: 'Hide password',
  showPasswordText: 'Show password'
};
var _default = InputField;
exports.default = _default;